module.exports = __webpack_public_path__ + "img/bootstrap.c6707de1.svg";